<template>
  <div class="prizes-page py-5 mb-5">
    <div class="container text-center">
      <h1 class="mb-4" v-html="$t('Prizes.Headline')"></h1>
      <p class="mb-4" v-html="$t('Home.IntroDesc')"></p>

      <router-link :to="{ name: 'Enter' }" class="btn btn-link" data-gtm-elem="navigation-click"
        data-gtm-card-type="Learn More" :data-gtm-card-title="$t('Prizes.Headline')"
        :data-gtm-link-text="$t('Prizes.Button')">
        {{ $t('Prizes.Button') }}
      </router-link>

      <p class="mt-4" v-html="$t('Prizes.CopyBelowButton')"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Prizes"
}
</script>
